import { makeStyles } from '@material-ui/core/styles';

export const useGiftCardInfoStyles = makeStyles(() => ({
  container: {
    backgroundColor: 'rgb(217, 217, 217)',
    borderRadius: (props) => (props.mobile ? 0 : '0px 0px 0px 10px'),
    padding: (props) => (props.mobile ? '40px 0px 20px 0px' : '40px'),
  },
  listItemText: {
    fontSize: 16,
  },
}));

export const useGiftCardAvailableStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: 'rgb(241, 241, 241)',
    borderRadius: (props) =>
      props.mobile ? '0px 0px 10px 10px' : '0px 0px 10px 0px',
  },
  balance: {
    fontSize: 26,
    color: theme.palette.primary.main,
    fontWeight: 600,
    textAlign: 'center',
    marginBottom: 10,
  },
  title: {
    textAlign: 'center',
    marginTop: (props) => (props.mobile ? 40 : -10),
    marginBottom: 10,
  },
  button: {
    width: 200,
    height: 40,
    marginBottom: (props) => (props.mobile ? 40 : 0),
  },
}));
